import React from 'react';

export function MetricCard({ label, value, change, changeType = 'neutral', icon }) {
  return (
    <div className="metric-card">
      <div className="metric-card-header">
        <div className="metric-card-label">
          {label}
        </div>
        <div className="metric-card-icon">
          {icon}
        </div>
      </div>
      
      <div className="metric-card-content">
        <div className="metric-card-value">
          {value}
        </div>
        {/* {change && (
          <div className={`metric-card-change ${changeType}`}>
            {change}
          </div>
        )} */}
      </div>
    </div>
  );
}
